export default __webpack_public_path__ + "static/media/Teotitlan shoot-by nikhol esteras.14cad714.jpg";